import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="logo-accent">Stop</span>Spoti
          </div>
          <p className="footer-text">
            An open-source utility designed to make your audio experience seamless.
          </p>
          <p className="copyright">&copy; {new Date().getFullYear()} StopSpoti. MIT Licensed.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
